import ViewListRoundedIcon from '@mui/icons-material/ViewListRounded';
import ViewModuleRoundedIcon from '@mui/icons-material/ViewModuleRounded';
import IconButton from '@mui/material/IconButton';
import Tooltip from '@mui/material/Tooltip';
import { useTranslation } from 'react-i18next';

import { EView } from 'src/interfaces/View';

interface Props {
  onSetView: (v: EView) => void;
  view: EView;
}

const ViewSwitch = ({ onSetView, view }: Props) => {
  const { t } = useTranslation();
  const isTableView = view === EView.table;
  const nextView = isTableView ? EView.grid : EView.table;
  const NextIcon = isTableView ? ViewModuleRoundedIcon : ViewListRoundedIcon;
  const tooltip = isTableView ? t('viewSwitch.gridView') : t('viewSwitch.listView');
  const ariaLabel = isTableView ? t('viewSwitch.grid') : t('viewSwitch.list');

  return (
    <Tooltip title={tooltip}>
      <IconButton
        size="small"
        color="primary"
        onClick={() => onSetView(nextView)}
        aria-label={ariaLabel}
      >
        <NextIcon />
      </IconButton>
    </Tooltip>
  );
};

export default ViewSwitch;
